import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import NewUploadFlow from './pages/NewUploadFlow';
import AdminPage from './pages/AdminPage';
import CustomerPortal from './pages/CustomerPortal';
import FAQPage from './pages/FAQPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import ContactPage from './pages/ContactPage';
import DTCDeletePage from './pages/DTCDeletePage';
import BlogPage from './pages/BlogPage';
import GuidesPage from './pages/GuidesPage';
import DTCRemovalPage from './pages/services/DTCRemovalPage';
import DPFOffPage from './pages/services/DPFOffPage';
import EGROffPage from './pages/services/EGROffPage';
import AdBlueOffPage from './pages/services/AdBlueOffPage';
import HowItWorksPage from './pages/HowItWorksPage';
import PricingPage from './pages/PricingPage';
import ServicesPage from './pages/ServicesPage';
import FileStorePage from './pages/FileStorePage';
import FileStoreProductPage from './pages/FileStoreProductPage';
import LatestFilesPage from './pages/LatestFilesPage';
import HowEcuTuningWorksPage from './pages/HowEcuTuningWorksPage';
import VehicleBrandGuidesPage from './pages/VehicleBrandGuidesPage';
import TroubleshootingGuidePage from './pages/TroubleshootingGuidePage';
import GlossaryPage from './pages/GlossaryPage';
import TestimonialsPage from './pages/TestimonialsPage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<NewUploadFlow />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/portal" element={<CustomerPortal />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Tools */}
          <Route path="/tools/dtc-delete" element={<DTCDeletePage />} />
          {/* Info Pages */}
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/services" element={<ServicesPage />} />
          {/* ECU File Store */}
          <Route path="/file-store" element={<FileStorePage />} />
          <Route path="/file-store/product/:slug" element={<FileStoreProductPage />} />
          {/* Latest Files */}
          <Route path="/latest-files" element={<LatestFilesPage />} />
          <Route path="/latest-files/:fileId" element={<LatestFilesPage />} />
          {/* Blog */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:articleId" element={<BlogPage />} />
          {/* Guides */}
          <Route path="/guides" element={<GuidesPage />} />
          {/* Service Pages */}
          <Route path="/services/dtc-removal" element={<DTCRemovalPage />} />
          <Route path="/services/dpf-off" element={<DPFOffPage />} />
          <Route path="/services/egr-off" element={<EGROffPage />} />
          <Route path="/services/adblue-off" element={<AdBlueOffPage />} />
          {/* Educational Content Pages */}
          <Route path="/how-ecu-tuning-works" element={<HowEcuTuningWorksPage />} />
          <Route path="/vehicle-tuning-guides" element={<VehicleBrandGuidesPage />} />
          <Route path="/troubleshooting-guide" element={<TroubleshootingGuidePage />} />
          <Route path="/glossary" element={<GlossaryPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
